import moment from 'moment';

/**
 * One place for how numbers, money, dates and status codes are shown, so every
 * screen reads the same way (2 decimals with thousands separators, "05 Mar 2026",
 * "Partially paid").
 */
export const money = (value, { blank = '-', decimals = 2 } = {}) => {
  if (value === null || value === undefined || value === '') return blank;
  const n = Number(value);
  if (Number.isNaN(n)) return blank;
  return n.toLocaleString('en-GB', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
};

/** Money with its currency, e.g. "EUR 1,250.00". */
export const amount = (value, currency = 'EUR', options) => {
  const text = money(value, options);
  return text === (options && options.blank) || text === '-' ? text : `${currency} ${text}`;
};

export const number = (value, decimals = 0, blank = '-') => money(value, { blank, decimals });

export const DATE_FORMAT = 'DD MMM YYYY';
export const DATE_TIME_FORMAT = 'DD MMM YYYY HH:mm';

export const date = (value, blank = '-') => (value ? moment(value).format(DATE_FORMAT) : blank);
export const dateTime = (value, blank = '-') => (value ? moment(value).format(DATE_TIME_FORMAT) : blank);

/** "PARTIALLY_PAID" -> "Partially paid"; also handles "ONE_OFF", "BANK_STATEMENT" etc. */
export const label = (code) => {
  if (code === null || code === undefined || code === '') return '-';
  const text = String(code).replace(/_/g, ' ').toLowerCase();
  return text.charAt(0).toUpperCase() + text.slice(1);
};

/** Status colours shared by the registers. */
export const STATUS_COLORS = {
  DRAFT: 'default',
  APPROVED: 'blue',
  ISSUED: 'blue',
  SENT: 'blue',
  PARTIALLY_PAID: 'gold',
  PAID: 'green',
  SIGNED: 'green',
  ACTIVE: 'green',
  COMPLETED: 'green',
  FILED: 'green',
  APPROVED_TS: 'green',
  PENDING: 'gold',
  SUBMITTED: 'gold',
  WORKING: 'processing',
  OPEN: 'blue',
  OVERDUE: 'red',
  DECLINED: 'red',
  CANCELLED: 'red',
  BLOCKED: 'red',
  INACTIVE: 'default',
  SUPERSEDED: 'default',
  LOST: 'red',
  CONVERTED: 'green',
};

export const statusColor = (code) => STATUS_COLORS[code] || 'default';

const formatters = { money, amount, number, date, dateTime, label, statusColor };
export default formatters;
